(function () {
  function findCard(target) {
    return target.closest('.cross-sell-card, [data-component="cross-sell-card"]');
  }

  function productUrlFromCard(card) {
    if (!card) return null;
    var titleLink = card.querySelector('.cross-sell-card__title a, a.cross-sell-card__details-link, .cross-sell-card__details-wrapper a');
    if (titleLink && titleLink.getAttribute('href')) return titleLink.getAttribute('href');
    var data = card.querySelector('script[data-component-data]');
    if (data) {
      try {
        var json = JSON.parse(data.textContent || '{}');
        var handle = json.product && json.product.handle;
        if (handle) return '/products/' + handle;
      } catch (e) {}
    }
    return null;
  }

  function variantIdFromCard(card) {
    if (!card) return null;
    var data = card.querySelector('script[data-component-data]');
    if (!data) return null;
    try {
      var json = JSON.parse(data.textContent || '{}');
      if (json.selectedVariant && json.selectedVariant.id) return json.selectedVariant.id;
      if (json.product && json.product.variants && json.product.variants[0]) {
        return json.product.variants[0].id;
      }
    } catch (e) {}
    return null;
  }

  function refreshCartDrawer(triggerEl, response) {
    try {
      if (window.Core && window.Core.Components) {
        var cartDrawer = window.Core.Components.getComponent('cart-drawer');
        if (cartDrawer && cartDrawer.data && cartDrawer.data.enabled && typeof cartDrawer.open === 'function') {
          cartDrawer.open(triggerEl, true, [response]);
          return;
        }
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  // Replace every ATC button's inner content with a real "+" character so it
  // renders reliably regardless of pseudo-element styling.
  function decorateAtcButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-cross-sell-card-atc]').forEach(function (btn) {
      if (btn.getAttribute('data-cross-sell-compact') === 'plus') return;
      btn.setAttribute('data-cross-sell-compact', 'plus');
      btn.setAttribute('aria-label', 'Add to cart');
      btn.textContent = '+';
    });
  }

  // Capture-phase click handler: runs before any component-level listeners.
  document.addEventListener('click', function (e) {
    // 1. Scroll arrows
    var prev = e.target.closest('.cart-cross-sell-arrow--prev');
    var next = e.target.closest('.cart-cross-sell-arrow--next');
    if (prev || next) {
      e.preventDefault();
      e.stopPropagation();
      var box = (prev || next).closest('.cross-sell, [data-component="product-cross-sell"]');
      if (!box) return;
      var wrapper = box.querySelector('.cross-sell__wrapper');
      if (!wrapper) return;
      var amt = wrapper.clientWidth / 2 + 5;
      wrapper.scrollBy({ left: prev ? -amt : amt, behavior: 'smooth' });
      return;
    }

    // 2. ATC button click → direct add via /cart/add.js, bypass variant flip
    var atc = e.target.closest('[data-cross-sell-card-atc]');
    if (atc) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (atc.disabled) return;
      var card = findCard(atc);
      var variantId = variantIdFromCard(card);
      if (!variantId) return;
      atc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) {
            console.error('Cart add error:', res.body);
            return;
          }
          var addedItem = (res.body.items && res.body.items[0]) || res.body;
          refreshCartDrawer(atc, addedItem);
        })
        .catch(function (err) { console.error('Cart add error:', err); })
        .finally(function () { atc.disabled = false; });
      return;
    }

    // 3. Card image click → navigate to product page
    // Skip if inside details/price (let those clicks pass through).
    if (e.target.closest('.cross-sell-card__details, .cross-sell-card__details-wrapper')) return;
    var imgArea = e.target.closest('.cross-sell-card__img, .cross-sell-card__img-product, [data-cross-sell-card-img]');
    if (!imgArea) return;
    var imgCard = findCard(imgArea);
    var url = productUrlFromCard(imgCard);
    if (url) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = url;
    }
  }, true);

  function updateArrowVisibility() {
    document.querySelectorAll('[data-component=product-cross-sell]').forEach(function (box) {
      var wrapper = box.querySelector('.cross-sell__wrapper');
      var arrows = box.querySelectorAll('.cart-cross-sell-arrow');
      if (!wrapper || !arrows.length) return;
      var canScroll = wrapper.scrollWidth > wrapper.clientWidth + 2;
      arrows.forEach(function (a) {
        a.style.display = canScroll ? '' : 'none';
      });
    });
  }

  function init() {
    decorateAtcButtons();
    updateArrowVisibility();
    // Observe document.body — Shopify's flyout component clones the cart
    // drawer content into a separate container at open time, so a narrower
    // observer on [data-cart-drawer] misses the cloned cross-sell cards.
    if (document.body && window.MutationObserver) {
      var debounced;
      var observer = new MutationObserver(function () {
        clearTimeout(debounced);
        debounced = setTimeout(function () {
          decorateAtcButtons();
          updateArrowVisibility();
        }, 60);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', updateArrowVisibility);
  document.addEventListener('cart:updated', function () {
    decorateAtcButtons();
    updateArrowVisibility();
  });
  document.addEventListener('shopify:cart:updated', function () {
    decorateAtcButtons();
    updateArrowVisibility();
  });
})();
